import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class NxI18nService {

  constructor(private translateService: TranslateService) {
  }

  public instant(type: string, id: string, translateType: string | string[]): any {
    let translateArray: string[];
    if (typeof translateType === 'string') {
      translateArray = [translateType, null];
    } else {
      translateArray = translateType;
    }
    let translatedItem;
    for (let i = 0; i < translateArray.length; i++) {
      if (!translateArray[i]) {
        return '';
      }
      const item = type + '.' + id + '.' + translateArray[i];
      translatedItem = this.translateService.instant(item);
      if (translatedItem !== item) {
        break;
      }
    }
    return translatedItem;
  }
}
